// extracted by mini-css-extract-plugin
export default {"draftMessage":"index_draftMessage__46drt","table-toolbar":"index_table-toolbar__1IyaD","left":"index_left__5ihV-","right":"index_right__akVKd"};